module.exports = __webpack_public_path__ + "static/media/poster.14467e92.jpg";